import React from "react";
import DesignSiteForm from "./design_site_form";

const CreateDesignSite: React.FC = () => {
  return <DesignSiteForm mode="create" />;
};

export default CreateDesignSite;
